/*
 * Build flag for the SERVER-side account phone write (my-api PUT /me/phone;
 * boardroom approval 2026-10-07). When VITE_PHONE_VIA_API === 'true' the
 * profile save sends the phone to my-api, which validates it and writes the
 * E.164 value to Cognito; every other attribute still goes direct. Absent or
 * anything else = OFF = today's direct Cognito write. Stage on, prod off until
 * the route is live there. The env is injectable so tests can pin both sides.
 */
export function phoneViaApiEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_PHONE_VIA_API === 'true'
}
